import Network from "../../../netWork/Network";
import ApiResponse from "../../../netWork/ApiResponse";
import OrderModel from "../../../models/appointmentManagement/dashboard/dashboardModel";

const useDashboard = () => {
    // 获取订单列表
    const getOrderList = async (params: Record<string, any>): Promise<{list: OrderModel[], totalPage: number, total: number}> => {
        try {
            const res = await Network.get<ApiResponse<any>>('/booking/security/order/list',  params );
            if(res.code === 200) {
                return {list: res.data.items.map((item: Record<string, any>) => new OrderModel(item)),
                    totalPage: Math.ceil(res.data.total / 10), 
                    total: res.data.total};
            } else {
                return {
                    list: [],
                    totalPage: 0,
                    total: 0,
                };
            }
        } catch (error) {
            return {
                list: [],
                totalPage: 0,
                total: 0,
            };
        }
    }
    // 安保核销订单
    const verifyOrder = async (params: Record<string, any>): Promise<{success: boolean, message: string}> => {
        try {
            const res = await Network.post<ApiResponse<any>>('/booking/security/order/verify', params);
            if(res.code === 200) {
                return {
                    success: true,
                    message: res.message,
                };
            }else{
                return {
                    success: false,
                    message: res.message,
                };
            }
        } catch (error:any) {
            return {
                success: false,
                message: error.message,
            };
        }
    }
    // 获取安保电话
    const getPhone = async (params: Record<string, any>): Promise<{phone:string}> => {
        try {
            const res = await Network.get<ApiResponse<any>>('/booking/admin/get-security-phone', params);
                if(res.code === 200) {
                    return {
                        phone:res.data.phone
                    };
                }else{
                    return {
                        phone:res.data.phone
                    };
                }
            } catch (error:any) {
                return {
                    phone:''
                };
            }
        }
    // 保存安保电话
    const updatePhone = async (params: Record<string, any>): Promise<{success: boolean, message: string}> => {
        try {
            const res = await Network.post<ApiResponse<any>>('/booking/admin/set-security-phone', params);
                if(res.code === 200) {
                    return {
                        success: true,
                        message: res.message,
                    };
                }else{
                    return {
                        success: false,
                        message: res.message,
                    };
                }
            } catch (error:any) {
                return {
                    success: false,
                    message: error.message,
                };
            }
        }
    return {
        getOrderList,
        verifyOrder,
        getPhone,
        updatePhone
    }
}
export default useDashboard;